import React from 'react';
import EditOutlined from '@mui/icons-material/EditOutlined';
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { useFeatureTheme } from '../../../../../theme/hooks/useFeatureTheme';
import { FORM_STUDIO_COPY } from '../../constants/formStudioConfig';
import { normalizeFieldOptions } from '../../utils/fieldOptionsUtils';
import FieldOptionsPreview from './FieldOptionsPreview';

export default function FieldStatusOptionsPanel({
  keyName,
  keyOptions,
  optionColors,
  disabled = false,
  onEditOptions,
}) {
  const { semantic, radiusPx, typographyStyles } = useFeatureTheme();
  const copy = FORM_STUDIO_COPY.statusField;
  const optionCount = normalizeFieldOptions(keyOptions).length;

  return (
    <Box
      sx={{
        p: { xs: 1.25, sm: 1.5 },
        borderRadius: radiusPx.md,
        border: `1px solid ${semantic.borders.border}`,
        bgcolor: semantic.surfaces.surfaceSubtle,
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        alignItems="flex-start"
        justifyContent="space-between"
        sx={{ mb: disabled ? 0 : 1 }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ ...typographyStyles.bodyText, fontWeight: 600 }}>
            {copy.optionsTitle}
            {!disabled && optionCount > 0 ? (
              <Box
                component="span"
                sx={{
                  ml: 0.75,
                  fontWeight: 500,
                  color: semantic.text.secondary,
                  fontSize: 12,
                }}
              >
                {optionCount}
              </Box>
            ) : null}
          </Typography>
          <Typography sx={{ ...typographyStyles.caption, color: semantic.text.secondary, mt: 0.5 }}>
            {copy.optionsCaption}
          </Typography>
        </Box>
        {!disabled && onEditOptions ? (
          <Tooltip title="Edit status options">
            <IconButton size="small" onClick={onEditOptions} sx={{ mt: -0.25 }}>
              <EditOutlined fontSize="small" />
            </IconButton>
          </Tooltip>
        ) : null}
      </Stack>

      {disabled ? (
        <Typography sx={{ ...typographyStyles.caption, color: semantic.text.secondary, mt: 1 }}>
          {copy.keyNameRequired}
        </Typography>
      ) : (
        <FieldOptionsPreview
          keyOptions={keyOptions}
          optionColors={optionColors}
          variant="embedded"
          emptyLabel="No status options yet. Use edit to add values."
        />
      )}
    </Box>
  );
}
